export default __webpack_public_path__ + "static/media/perfume_모바일.655980ee.jpg";